import script from "./Bar.vue?vue&type=script&setup=true&lang=js"
export * from "./Bar.vue?vue&type=script&setup=true&lang=js"

import "./Bar.vue?vue&type=style&index=0&id=22516128&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22516128"]])

export default __exports__